import 'css-chunksrc/client/scenes/listEdition/listEditionForm/styles.scss';export default {
  "listEditionForm": "_listEditionForm_145ht_1",
  "group": "_group_145ht_5",
  "title": "_title_145ht_9",
  "dateGroup": "_dateGroup_145ht_14",
  "textInput": "_textInput_145ht_24",
  "dateTimeInput": "_dateTimeInput_145ht_28",
  "row": "_row_145ht_33",
  "textArea": "_textArea_145ht_43"
};